import * as easingFunctions from 'js-easing-functions';

// INPUT:

// value
// array of numbers
// array of array
// array of objects

const tween = function (params) {
  switch (typeof params.start) {
    case 'number':
      loopFunction (params, 'number');
      break;
    case 'object':
      loopFunction (params, 'object');
      break;
  }
};

function iterate (params, t) {
  for (var i = 0; i < params.start.length; i++) {
    if (params.start[i].length >= 0) {
      // Array of array
      for (var j = 0; j < params.start[i].length; j++) {
        tweenFunction (
          {...params, start: params.start[i][j], end: params.end[i][j]},
          t,
          i,
          j
        );
      }
    } else {
      // Array of objects
      tweenFunction (
        {...params, start: params.start[i], end: params.end[i]},
        t,
        i
      );
    }
  }
}

const loopFunction = (params, type) => {
  let startTime = performance.now ();
  const loop = () => {
    var t = performance.now () - startTime;
    if (t <= params.duration) {
      if (type === 'number') {
        tweenFunction (params, t);
      } else {
        iterate (params, t);
      }
      window.requestAnimationFrame (loop);
    }
  };
  window.requestAnimationFrame (loop);
};

const easeFunction = function (t, start, end, duration, ease) {
  let interval = end - start;
  // let progress = t / duration;
  return easingFunctions[ease] (t, start, interval, duration);
  // return start + interval * computedProgress;
};

const tweenFunction = function (params, t, index = null, secondIndex = null) {
  if (!params.ease) params.ease = 'easeInOutCubic';
  if (index !== null) {
    // Array
    if (typeof params.start === 'number') {
      if (secondIndex !== null) {
        // Array of array
        let start = params.start;
        let end = params.end;
        let value = easeFunction (t, start, end, params.duration, params.ease);

        params.prop[index].splice ([secondIndex], 1, value);
      } else {
        // Array
        let start = params.start;
        let end = params.end;
        let value = easeFunction (t, start, end, params.duration, params.ease);

        params.prop.splice (index, 1, value);
      }
    } else {
      // Array of Objects
      let item = params.prop[index];
      for (var k = 0; k < params.keys.length; k++) {
        let start = params.start[params.keys[k]];
        let end = params.end[params.keys[k]];
        let value = easeFunction (t, start, end, params.duration, params.ease);

        item[params.keys[k]] = value;
      }
      params.prop.splice (index, 1, item);
    }
  } else {
    // Number
    let start = params.start[params.keys[k]];
    let end = params.end[params.keys[k]];
    let value = easeFunction (t, start, end, params.duration, params.ease);

    params.prop = value;
  }
};

export {tween};
